import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ShimmerThumbnail } from '../Image';
import ShimmerTitle from '../Title';
import ShimmerText from '../Text';
import ShimmerButton from '../Button';
import ShimmerCard from '../Card';

const ShimmerContentBlock = ({
  card,
  title,
  text,
  cta,
  thumbnailWidth,
  thumbnailHeight,
  reverse,
  className,
}) => {
  const renderContent = () => {
    return cta && title && text ? (
      <div
        className={classNames({
          flex: true,
          'flex-reverse': reverse,
        })}>
        <div
          className={classNames({
            flex: true,
            'w-50': !thumbnailWidth,
          })}>
          <ShimmerThumbnail
            style={{
              width: `${thumbnailWidth} !important`,
              height: `${thumbnailHeight} !important`,
            }}
            className="h-100 m-0"
          />
        </div>
        <div className=" d-flex p-20 w-100">
          <div className="w-70">
            {title && <ShimmerTitle className="w-40" line={1} />}
            {text && <ShimmerText line={3} gap={10} />}
          </div>
          <div className="w-30">
            {cta && (
              <>
                <ShimmerButton className={''} />
                <ShimmerButton className={''} />
              </>
            )}
          </div>
        </div>
      </div>
    ) : (
      <ShimmerThumbnail
        style={{
          width: `${thumbnailWidth} !important`,
          height: `${thumbnailHeight} !important`,
        }}
        className="h-100 m-0"
      />
    );
  };

  if (!card) return renderContent();

  return (
    <ShimmerCard
      className={classNames({
        [className]: className,
      })}>
      {renderContent()}
    </ShimmerCard>
  );
};

ShimmerContentBlock.propTypes = {
  card: PropTypes.bool,
  title: PropTypes.bool,
  text: PropTypes.bool,
  cta: PropTypes.bool,
  thumbnailWidth: PropTypes.any,
  thumbnailHeight: PropTypes.any,
  reverse: PropTypes.bool,
  className: PropTypes.string,
};

ShimmerContentBlock.defaultProps = {
  card: true,
  title: false,
  text: false,
  cta: false,
  reverse: false,
  className: false,
};
export default ShimmerContentBlock;
